/**
 * Dashboard - Frontend
 * @description Dashboard principal simplificado
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, Smartphone } from 'lucide-react';

// Hooks and contexts
import { useAuth } from '@/contexts/AuthContext';
import { useNavigationHelpers } from '@/utils/navigationHelpers';

export const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { navigateWithTokenCheck } = useNavigationHelpers();

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Dashboard</h1>
          <p className="text-gray-600">Welcome back, {user?.name || user?.username || 'User'}</p>
        </div>

        {/* Main Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* My Devices Card */}
          <div
            onClick={() => navigateWithTokenCheck(navigate, '/operations')}
            className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-200 hover:border-blue-300 transform hover:scale-105"
          >
            <div className="p-8 text-center">
              <div className="inline-flex p-4 rounded-full mb-6 bg-blue-500 text-white">
                <Smartphone className="h-8 w-8" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">My Devices</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Monitor and manage your assigned devices with real-time status
              </p>
              <div className="inline-flex items-center px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-600">
                Real-time updates
              </div>
            </div>
          </div>

          {/* All Lectures Card */}
          <div
            onClick={() => navigateWithTokenCheck(navigate, '/operations/device/all-lectures')}
            className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-200 hover:border-blue-300 transform hover:scale-105"
          >
            <div className="p-8 text-center">
              <div className="inline-flex p-4 rounded-full mb-6 bg-green-500 text-white">
                <Activity className="h-8 w-8" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">All Lectures</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Comprehensive view of all device readings and operations
              </p>
              <div className="inline-flex items-center px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-600">
                Unified view
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
